// extracted by mini-css-extract-plugin
module.exports = {"creditCard":"CreditCardIcon__creditCard___jbJtJ","stroked":"CreditCardIcon__stroked___3qKDO","filled":"CreditCardIcon__filled___FloaU"};